import React from 'react';
import { useEventContext } from '../../public_event/contexts/EventContext';
import { SessionModal } from './SessionModal';
import type { ScheduleSession } from '../../types/schedule.types';

interface SessionModalWithContextProps {
  session: ScheduleSession;
  onClose: () => void;
  timeZoneLabel?: string;
  onCalendarAdd?: (type: 'google' | 'outlook' | 'apple' | 'outlookcom' | 'office365' | 'yahoo') => void;
  ModalWrapper: React.ComponentType<{ isOpen: boolean; onClose: () => void; children: React.ReactNode }>;
  onSpeakerClick?: (speakerId: string) => void;
  SpeakerModal?: React.ComponentType<{ speaker: any; onClose: () => void }>;
  speakers?: any[];
  primaryColor?: string;
  eventDetails?: any;
}

// This component gets eventSlug from context and passes it to SessionModal
export const SessionModalWithContext: React.FC<SessionModalWithContextProps> = (props) => {
  const { eventSlug } = useEventContext();
  
  return <SessionModal {...props} eventSlug={eventSlug} />;
};